// extracted by mini-css-extract-plugin
export default {"body-popup-view-all-serial":"PopupViewAllSerial_body-popup-view-all-serial__vRNrZ","custom-tag":"PopupViewAllSerial_custom-tag__zgThu","inline":"PopupViewAllSerial_inline__adNfo"};